import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=84a7ffcc&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"
import style0 from "./table-list.vue?vue&type=style&index=0&id=84a7ffcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a7ffcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a7ffcc')) {
      api.createRecord('84a7ffcc', component.options)
    } else {
      api.reload('84a7ffcc', component.options)
    }
    module.hot.accept("./table-list.vue?vue&type=template&id=84a7ffcc&scoped=true&", function () {
      api.rerender('84a7ffcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/buyer/modules/table-list.vue"
export default component.exports